import type { FC, ReactNode } from 'react'

import type { SwipeableProps } from 'react-swipeable'
import { useSwipeable } from 'react-swipeable'

export const Swipeable: FC<
  SwipeableProps & {
    id?: string
    className?: string
    children: ReactNode
    onClick?: () => void
  }
> = ({ id, className, children, onClick, ...props }) => {
  const handlers = useSwipeable(props)

  const options = {
    role: 'button',
    onClick: onClick,
    onKeyDown: onClick,
  }

  return (
    <div id={id} className={className} {...(onClick && options)} {...handlers}>
      {children}
    </div>
  )
}

export { useSwipeable } from 'react-swipeable'
